export enum RideDeleteActionsResultEnum {
  NewBooking = "NewBooking",
  CancelBooking = "CancelBooking",
  NotChangeBookingStatus = "NotChangeBookingStatus",
  NoAction = "NoAction",
}
